import { render } from "./LoginFechaNacimiento.vue?vue&type=template&id=9af9adee"
import script from "./LoginFechaNacimiento.vue?vue&type=script&lang=js"
export * from "./LoginFechaNacimiento.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__